import Bb from 'backbone';
import { View } from 'backbone.marionette';

import template from './index.jst';

class DidYouPlayView extends View {

	get template() {
		return template;
	}

	get className() {
		return "onboarding-form onboarding-did-you-play";
	}

	ui() {
		return {
			yes: '.js-yes',
			no : '.js-no'
		};
	}

	events() {
		return {
			'click @ui.yes': 'onClickYes',
			'click @ui.no': 'onClickNo'
		};
	}

	initialize() {
		this.onboarding = this.getOption('onboarding');
		this.model = new Bb.Model();
		this.model.set({
			game_title: this.onboarding.get('game_title')
		});
	}

	onClickYes() {
		this.onboarding.set({
			current_step: 'LinkAccount',
			LinkAccount_back_url: 'DidYouPlay'
		});
	}

	onClickNo() {
		this.onboarding.set({
			current_step: 'NoMatchStartPlaying',
			NoMatchStartPlaying_back_url: 'DidYouPlay'
		});
	}
}

export default DidYouPlayView;